module.exports = __webpack_public_path__ + "images/25e95827552add638318a316a27ad50e.jpg";